var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-field",
        {
          attrs: {
            error: _vm.error,
            "error-label": "Invalid User",
            helper: _vm.helper
          }
        },
        [
          !_vm.hide
            ? _c(
                "q-search",
                {
                  attrs: {
                    placeholder: _vm.placeholder,
                    clearable: _vm.clearable
                  },
                  on: { clear: _vm.clearMethod },
                  model: {
                    value: _vm.filter,
                    callback: function($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter"
                  }
                },
                [
                  _c("q-autocomplete", {
                    ref: "userAutoComplete",
                    attrs: { debounce: 500, "max-results": _vm.maxResults },
                    on: { search: _vm.onSearch, selected: _vm.onSelectMethod }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }